import { z } from 'zod';

/** Общие примитивы контрактов. */

export const UuidSchema = z.string().uuid();

/** Пагинация списков админки (§13). */
export const PageQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(200).default(50),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;

export const pageResultSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    total: z.number().int().min(0),
    page: z.number().int().min(1),
    perPage: z.number().int().min(1),
  });

export type PageResult<T> = {
  items: T[];
  total: number;
  page: number;
  perPage: number;
};

/**
 * Единый формат ошибки API.
 * §18: наружу уходит код и безопасное описание, без секретов и текстов сообщений.
 */
export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.unknown()).optional(),
  /**
   * Идентификатор запроса: его проставляет обработчик ошибок сервера
   * (`all-exceptions.filter.ts`) во все ответы. Интерфейс показывает его на
   * аварийном экране — с ним обращение к администратору осмысленно, а по
   * журналам событие находится за один поиск.
   */
  correlationId: z.string().optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

/**
 * Период создания записи: фильтр списков §13 и дашборда §14.
 *
 * Верхняя граница **исключающая**: интерфейс отдаёт день, а день заканчивается
 * началом следующего. С включающей границей «с 15.08 по 15.08» означало бы
 * «ровно полночь» и возвращало пустой список.
 */
export const CREATED_RANGE_SHAPE = {
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
} as const;

/** Период для фильтров дашборда (§14). Границы — ISO-8601 в UTC. */
export const DateRangeSchema = z.object({
  from: z.string().datetime(),
  to: z.string().datetime(),
});
export type DateRange = z.infer<typeof DateRangeSchema>;
